/**
 * Login screen for Facer PRO SSO (LC_AUTH_MODE=facer).
 * The platform is launched from Facer PRO («Инструменты» → Landing Console), so we
 * just point the user there. `ssoError` is shown when a token was rejected (e.g.
 * the position has no access to the platform).
 */
export function FacerLogin({ facerUrl, ssoError }: { facerUrl: string | null; ssoError: boolean }) {
  return (
    <div className="center">
      <div className="card" style={{ padding: 28, width: 400, textAlign: "left" }}>
        <div className="brand" style={{ marginBottom: 14 }}>
          <span className="mk">🌐</span>Сайты маркетинга
        </div>
        {ssoError ? (
          <div className="err" style={{ marginBottom: 12 }}>
            Вход не выполнен: у вашей должности нет доступа к платформе, либо ссылка устарела.
            Откройте платформу заново из Facer PRO.
          </div>
        ) : (
          <p className="muted" style={{ marginTop: 0 }}>
            Вход на платформу — через <b>Facer PRO</b>. Откройте раздел «Инструменты» и нажмите
            плитку «Сайты маркетинга».
          </p>
        )}
        {facerUrl ? (
          <a className="btn primary big" href={facerUrl}>
            Открыть Facer PRO →
          </a>
        ) : (
          <div className="empty-note">
            Зайдите в Facer PRO → «Инструменты» → «Сайты маркетинга». Прямой вход по адресу
            платформы недоступен — доступ выдаётся через единый вход.
          </div>
        )}
      </div>
    </div>
  );
}
